require('./highcharts')
require('./jquery.autocomplete')
require('./jquery.are-you-sure')
require('./moment')